module.exports = __webpack_public_path__ + "static/img/bannerLogo.eaed21d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/center/bannerLogo.jpg
// module id = rk/q
// module chunks = 1